export const publicUrls = [
    "/PublicSession",
    "/Overlay",
    "/PublicSessionInfo", 
    "/user/email-confirm", 
    "/user/forgot-password", 
    "/user/reset-password", 
    "/adfs", 
    "/two-factor",
    "/authenticate", 
    "/public/attachment/viewer", 
    "/loggedout"
];
